import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Excluir peticiones a Keycloak del interceptor para evitar dependencia circular
  const isKeycloakRequest = req.url.includes('keycloak') || req.url.includes('protocol/openid-connect');
  const isPublicApi = req.url.includes('/public/');
  const injector = inject(Injector);

  if (isKeycloakRequest) {
    return next(req);
  }

  // Obtener token directamente del localStorage para evitar dependencia circular
  let token: string | null = null;
  try {
    token = localStorage.getItem('access_token');
  } catch {
    // Si no hay acceso a localStorage, continuar sin token
  }

  if (!token && !isPublicApi) {
    // Sin sesión: no mandar la petición a ciegas; forzar re-login
    injector.get(AuthService).handleSessionExpired();
    return throwError(
      () =>
        new HttpErrorResponse({
          status: 401,
          statusText: 'Missing access token',
          url: req.url
        })
    );
  }

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isPublicApi) {
        // Lazy resolve: evita ciclo DI AuthService <-> HttpClient en el bootstrap del interceptor.
        // Un 401 con token aún vigente suele ser autorización (privilegios), no sesión vencida.
        const auth = injector.get(AuthService);
        if (!auth.isAccessTokenValid()) {
          auth.handleSessionExpired();
        }
      }

      return throwError(() => error);
    })
  );
};
